class AgencyBillingClosureResponse {
    id: string = '';
    billingPeriodId: string = '';
    agencyId: string = '';
    agencyName: string = '';
    closureDate: number = 0;
    closedBy: string = '';
    totalAmount: number = 0;
    notes: string = '';

    constructor(
        id: string,
        billingPeriodId: string,
        agencyId: string,
        agencyName: string,
        closureDate: number,
        closedBy: string,
        totalAmount: number,
        notes: string,
    ) {
        this.id = id;
        this.billingPeriodId = billingPeriodId;
        this.agencyId = agencyId;
        this.agencyName = agencyName;
        this.closureDate = closureDate;
        this.closedBy = closedBy;
        this.totalAmount = totalAmount;
        this.notes = notes;
    }
}

export default AgencyBillingClosureResponse;